import React from 'react';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import DownloadIcon from '@wix/da-ds/pkg/Icons/24x24/Download';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarButton from '../../_partials/items/ActionBarButton';
/** Begins a pcp download for a deviation that only has no free download
 *  and the user has already purchased the pcp */
var PcpDownloadLink = function (_a) {
    var deviation = _a.deviation, onDownload = _a.onDownload, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, iconRef = _a.iconRef;
    var t = useTranslation().t;
    return (React.createElement(ActionBarItemWrapper, { tooltip: t('actionbar.download') },
        React.createElement(ActionBarButton, { href: get(deviation, 'extended.pcp.url'), target: "_blank", download: true, onClick: onDownload, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, biData: {
                evid: BiEventType.CLICK_DOWNLOAD_BUTTON,
                deviationid: deviation.deviationId,
                ispaiddownload: 1,
            } },
            React.createElement(ActionBarIcon, { icon: DownloadIcon, iconRef: iconRef }))));
};
PcpDownloadLink.displayName = 'PcpDownloadLink';
export default PcpDownloadLink;
//# sourceMappingURL=PcpDownloadLink.js.map